import React from 'react'
import toast from 'react-hot-toast'

import {
  BooleanField,
  FieldSpec,
  LinkedField,
  PaginatedTable,
  RelatedLinkedField,
  RowAction,
  ValueField
} from 'src/components/Table'
import { skuit } from 'src/services/skuit'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  name: { id: 'name', label: 'Name', renderer: LinkedField(ValueField) },
  client: { id: 'client', label: 'Client', renderer: RelatedLinkedField(ValueField, 'name') },
  autoSync: { id: 'autoSync', label: 'Auto-Sync', renderer: BooleanField },
}

const possibleRowActions: { [key: string]: RowAction } = {
  sync: {title: () => 'Sync', onClick: (row) => skuit.sc.carts.sync(row.guid).then(() => toast.success(`${row.name} scheduled for sync`)).catch(() => toast.error(`${row.name} failed to sync`))}
}

export const CartListTable = (props: ListTableProps) => {
  const { paginator, fields, title = 'Cart Integrations', rowActions } = props

  return (
    <>
      <PaginatedTable
        title={title}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        rowActions={rowActions?.map((action) => possibleRowActions[action])}
      />
    </>
  )
}
